/* eslint-disable prettier/prettier */
import React from 'react';
import styled, { css } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Icon, theme } from 'fpay-ui';
import { useDispatch } from 'react-redux';
import { resendSendInvitation } from 'redux/config/actions';
import { isAllowed } from '@helpers/auth';

const Container = styled.div`
  ${({ theme }) => css`
    width: 100vw;
    padding: 20px;
    padding-left: 24px;
    background-color: #ffeebf;
    color: #8a670f;
    margin: 5px -24px 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    ${theme.breakpoint('md')} {
      border-radius: 6px;
      width: 100%;
      align-self: center;
      padding: 16px 24px 16px 24px;
    }
  `}
`;
const ImageContainer = styled.div`
  width: 15.5px;
  margin-right: 17px;
  flex-shrink: 0;
  img {
    width: 100%;
  }
  ${({ theme }) => theme.breakpoint('md')} {
    width: 21.7px;
    height: 21.7px;
    margin-right: 18.3px;
  }
`;
const Text = styled.div`
  ${({ theme }) => css`
    color: #8a670f;
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    margin-left: 10px;
    @media (min-width: 600px) {
      color: #8a670f;
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      max-width: 711px;
    }
  `}
`;
const CloseIcon = styled.div`
  width: 18px;
  flex-shrink: 0;
  margin-left: auto;
  margin-right: 16px;
  cursor: pointer;
  img {
    width: 100%;
  }
  @media (min-width: 600px) {
    margin-right: 0px;
  }
  ${({ theme }) => theme.breakpoint('md')} {
    width: 24px;
    height: 24px;
  }
`;

const Link = styled.span`
  color: #0071ce;
  text-align: center;
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  cursor: pointer;
  @media (min-width: 600px) {
    font-size: 14px;
  }
  &:hover {
    text-decoration: underline;
  }
`;

const TycWarning = ({ closeWarning }) => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(resendSendInvitation());
  };

  const showLink = isAllowed('LINK_RESEND_MAIL_TYC');

  return (
    <>
      <Container>
        <ImageContainer>
          <Icon icon="ic-information" />
        </ImageContainer>
        <Text>
          {t('foundsOut.tycWarning')}
          {showLink && <Link onClick={handleClick}>{t('foundsOut.resend')}</Link>}
        </Text>
        <CloseIcon onClick={closeWarning}>
          <Icon icon="ic-close" color={`${theme.colors.ybrand800}`} />
        </CloseIcon>
      </Container>
    </>
  );
};

export default TycWarning;
